import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {RouterLink} from '@angular/router';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-post-view',
  templateUrl: './post-view.component.html',
  imports: [
    RouterLink,
    NgIf
  ],
  styleUrls: ['./post-view.component.scss']
})
export class PostViewComponent implements OnInit {

  @Input() postData: any;

  public blogImage: any;
  public blogData: any;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.blogImage = this.sanitizer.bypassSecurityTrustStyle(`url(${this.postData.post_image})`);
    this.blogData = this.sanitizer.bypassSecurityTrustHtml(this.postData.post_content);
  }
}
